/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};

GS.Toolbar.Input = new Class({
    Extends: GS.BaseClass,
    class_name:'GS.Toolbar.Input',
    inputEl : null,
    options : {
        min : 0,
        max : 1,
        step: 1
    },
    initialize:function(ele,conf){
        this.parent(conf);
        this.configure(ele);
    }
});

GS.Toolbar.Input.prototype.configure = function(ele) {
    var self = this,
        _platformCTRL = Browser.Platform === 'mac' ? 'metaKey' : 'ctrlKey';


    this.inputEl = new Element('input',{
        'class' : 'slider_input',
        'type' : 'number',
        'value' : 0,
        events : {
            /*'paste' : function(e){
                e.preventDefault();
                e.stopPropagation();
                return false;
            },*/
            'keypress' : function(e){
                //console.log(e.event);
                var _skeep= [9,44,46,37,38,39,40],
                    _skeepCopyPaste=[97,99,118],
                    _keyCode = e.event.keyCode || e.event.charCode;
                if((_skeep.indexOf(_keyCode)===-1 && (!e.event[_platformCTRL] || _skeepCopyPaste.indexOf(_keyCode)===-1)) && (_keyCode < 48 || _keyCode > 57) ) {
                    console.debug('Prevented!', _keyCode);
                    e.preventDefault();
                    return;
                }
                
                
            },
            'input' : function(e){
                var _val = e.target.value.replace(',','.'),
                    _original = Number(_val);
            
                //console.warn(e.target.value);
                if(!/[\.|\,]$/.test(_val)){
                    _val = Number(_val.replace(/(,+)/,'.'));
                    if(isNaN(_val)) _val = self.options.min;
                    _val = Math.max(self.options.min,_val);
                    _val = Math.min(self.options.max,_val);
                    //console.warn('Min: %s, Value: %s, Max:%s', self.options.min, _val, Math.min(self.options.max));
                    if(_original !== _val) self.inputEl.value = _val;
                    self.fireEvent('input:change',_val);
                }
            },
            'click' : function(e){
                e.stopPropagation();
            }
        }
    });
    this.inputEl.inject(ele.getElement('.slider-wrapper'),'before');
};

GS.Toolbar.Input.prototype.setValue = function(v) {
    this.inputEl.set('value',Number(v.toFixed(1)));
};

GS.Toolbar.Input.prototype.setMinMax = function(min, max, step){
    this.options.min = min;
    this.options.max = max;
    this.inputEl.setAttribute('min',min);
    this.inputEl.setAttribute('max',max);
    this.setStep(step || 1);
};

GS.Toolbar.Input.prototype.setStep = function(step){
    this.options.step = Number(step);
    this.inputEl.setAttribute('step',this.options.step);
};


